import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { GalleryContentFormComponent } from './gallery-content-form/gallery-content-form.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: GalleryContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.GALLERY, true, '/#/content/create/1'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: GalleryContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.GALLERY, true, '/#/content/:id'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: GalleryContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.GALLERY, true, '/#/content/:id'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GalleryContentRoutingModule {}
